import styled from "styled-components";

export const WidthWrapper = styled.div<{ $width: number }>`
  width: ${(props) => props.$width}px;
`;
